import { createContext, useContext, useLayoutEffect, useState } from 'react';
import type { StoreApi } from 'zustand';
import { useStore } from 'zustand';

import {
  createSearchStore,
  INITIAL_SEARCH_CONTEXT_STATE,
} from '../../store/search-store';
import type { SearchContextType, SearchProviderType } from '../../types';

const SearchContext = createContext<StoreApi<SearchContextType>>(
  createSearchStore(INITIAL_SEARCH_CONTEXT_STATE)
);

export const useSearchStore = <T,>(
  selector: (store: SearchContextType) => T
): T => {
  const store = useContext(SearchContext);

  return useStore(store, selector);
};

export const useSearchContext = (): SearchContextType => {
  return useSearchStore((store) => store);
};

export const SearchProvider: React.FC<SearchProviderType> = ({
  children,
  context,
}) => {
  const [store] = useState(() => createSearchStore(context));

  useLayoutEffect(() => {
    store.setState(context);
  }, [context, store]);

  return (
    <SearchContext.Provider value={store}>{children}</SearchContext.Provider>
  );
};
